'use client'
import{QRCodeCanvas as a}from"qrcode.react";import{jsx as l}from"react/jsx-runtime";var b=({value:e,id:r,size:o=100,className:t,level:i,imageSettings:s,bgColor:g,fgColor:n})=>l(a,{id:r,value:e,size:o,className:t,level:i||"H",imageSettings:s,bgColor:g,fgColor:n});export{b as a};
